import { render, staticRenderFns } from "./issue-detail.vue?vue&type=template&id=964c8a06&scoped=true"
import script from "./issue-detail.vue?vue&type=script&lang=js"
export * from "./issue-detail.vue?vue&type=script&lang=js"
import style0 from "./issue-detail.vue?vue&type=style&index=0&id=964c8a06&prod&scoped=true&lang=css"
import style1 from "./issue-detail.vue?vue&type=style&index=1&id=964c8a06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964c8a06",
  null
  
)

export default component.exports